import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { ScenarioService } from '../services/scenario.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { EditorService } from '../services/editor.service';
import { Router } from '@angular/router';
import { PreviewService } from '../services/preview.service';
import { AuthService } from '../auth/service/auth.service';
import { UpgradeService } from '../services/upgrade.service';
import { AutosaveService } from '../services/autosave.service';
import { MementoService } from '../services/memento.service';
import { UserService } from '../auth/service/user.service';
import { AiService } from '../services/ai.service';
import { PlayerSessionService } from '../services/player-session.service';

@Component({
  selector: 'app-navbar-user',
  templateUrl: './navbar-user.component.html',
  styleUrls: ['./navbar-user.component.scss'],
})
export class NavbarUserComponent {
  currentUser: any;
  userSub: any;
  scenarios: any;
  @Input() navMode = 'step';
  @Input() active = '';
  @Input() scenario: any;
  @Input() step: any;
  @Input() page: any;
  @Input() subpage: any;
  isLoading = false;
  collapsed = false;

  monthlyAis: any = 0;

  aiCreditLimit: any;
  userData: any;
  playLimit: any;
  scenarioLimit: any;
  monthlyPlays: any;

  activeScenarioSub: any;
  activeScenario: any;
  userDataSub:any;

  constructor(
    private scenarioService: ScenarioService,
    private renderer: Renderer2,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private editorService: EditorService,
    private eRef: ElementRef,
    private router: Router,
    private previewService: PreviewService,
    private authService: AuthService,
    private upgradeService: UpgradeService,
    private autosaveService: AutosaveService,
    private mementoService: MementoService,
    private userService: UserService,
    private aiService: AiService,
    private playerSessionService: PlayerSessionService
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'has-user-navbar');

    this.scenarioService.fetchAll().subscribe((responseData) => {
      this.scenarios = responseData;
    });

    this.userSub = this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.currentUser = userData;
      } else {
        this.currentUser = null;
      }
    });

    this.userDataSub = this.userService.userData.subscribe((userData: any) => {
      if (userData) {
        this.userData = userData;
        this.currentUser = userData;
        switch (userData.role_id) {
          case 1:
            this.aiCreditLimit = 1000;
            break;
          case 2:
            this.playLimit = 1000;
            this.scenarioLimit = 1;
            this.aiCreditLimit = 1;
            break;
          case 3:
            this.playLimit = 250000;
            this.scenarioLimit = 1000;
            this.aiCreditLimit = 30;
            break;
          case 4:
            this.playLimit = 500000;
            this.scenarioLimit = null;
            this.aiCreditLimit = 100;
            break;
          case 5:
            this.playLimit = null;
            this.scenarioLimit = null;
            this.aiCreditLimit = 1000;
            break;
        }
      }
    });
    this.playerSessionService
      .fetchMonthlyPlays(null, true)
      .subscribe((responseData: any) => {
        this.monthlyPlays = responseData[0].plays;
      });
    this.aiService.getCreditsUsed().subscribe((responseData: any) => {
      this.monthlyAis = responseData.credits_used;
    });

    this.activeScenarioSub = this.scenarioService.data.subscribe(
      (responseData: any) => {
        if (responseData) {
          this.activeScenario = {
            id: responseData?.id,
            title: responseData?.title,
          };
        }
      }
    );
  }



  onLogout() {
    this.router.navigate(['/']);
    this.authService.logout();
    // unsubscribe from scenario data here?
    this.scenarioService.data.next(null);

    this.autosaveService.stop();
    this.mementoService.clear();
  }
  onGoToScenario(scenarioId: any) {
    this.isLoading = true;
    this.scenarioService.fetch(scenarioId).subscribe((responseData) => {
      this.scenarioService.setData(responseData.scenario_data);
      this.router.navigate(['/steps', scenarioId]);
      this.isLoading = false;
    });
  }

  onChangeTitle() {
    let inputElem = document.getElementById('step-title-input');
    if (inputElem) {
      inputElem.style.width = this.step.title.length + 'ch';
    }
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'has-user-navbar');
    this.activeScenarioSub.unsubscribe();
    this.userDataSub.unsubscribe();
    this.userSub.unsubscribe();
  }
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  getByStatus(scenarios: any, status: any, query?: string) {
    let returnScenarios = [];
    if (scenarios) {
      returnScenarios = scenarios.filter((scenario: any) => {
        return (
          scenario.status == status &&
          (!query ||
            (query &&
              scenario.title.toLowerCase().includes(query.toLowerCase())))
        );
      });

      return returnScenarios;
    }
  }
}
